import React from "react";
import {
	ChatMinimizeButton,
	ChannelSportsHeader,
	ChatCloseButton,
} from "@features/chat/mobile";

export default function ChatHeader() {
	return (
		<div className="chat__header">
			<ChannelSportsHeader />
			<div className="chat__header__actions">
				<ChatMinimizeButton />
				<ChatCloseButton />
			</div>
		</div>
	);
}
